export const apiEndPoints = 'https://auth.healthy4life.ai';
// export const apiEndPoints = 'http://api.facescan.localhost';
// export const apiEndPoints = 'https://facescanadmin-v2.bytesparkinc.com';
// export const apiEndPoints = 'https://admin.globalhealthiq.ai';
// export const imagePath = 'https://d1dxy9jb08jb13.cloudfront.net/'
export const imagePath = 'https://d51j8mtjqupqz.cloudfront.net/'
export const productImgPath = "https://media2.4life.com/"

export const urls = {
    startScan: `${apiEndPoints}/user/scan/create`,
    getDeviceId: `${apiEndPoints}/auth/get_device_id`,
    getCompanyDetails: `${apiEndPoints}/company/app/get-detail`,
    checkUserRegistration: `${apiEndPoints}/auth/check_user_registration`,
    userLogin: `${apiEndPoints}/auth/user_login`,
    sendEmailOTP: `${apiEndPoints}/auth/send_email_otp`,
    verifyOTP: `${apiEndPoints}/auth/verify_email_otp`,
    resetPassword: `${apiEndPoints}/auth/user_set_password`,
    doLogout: `${apiEndPoints}/auth/logout`,
    ssoLogin: `${apiEndPoints}/sso/login`,
    getRefreshToken: `${apiEndPoints}/jwt/refresh-token`,
    completeSignup: `${apiEndPoints}/auth/user_signup`,
    traslateLabels: `${apiEndPoints}/auth/get_label_translations`,
    userLastSeen: `${apiEndPoints}/user/heart-beat`,
    userDetails: `${apiEndPoints}/user/get-detail`,
    updateUserDetails: `${apiEndPoints}/user/update_details`,
    deleteUserAcc: `${apiEndPoints}/auth/delete_user_account`,
    getFaqList: `${apiEndPoints}/faqs`,
    uploadCroppedImg: `${apiEndPoints}/auth/cropped-image-upload`,
    getLanguage: `${apiEndPoints}/company/get-language`,
    uploadDocument: `${apiEndPoints}/documents/upload`,
    getDocumentList: `${apiEndPoints}/documents/list`,
    deleteDocument: `${apiEndPoints}/documents/delete`,
    previewDocument: `${apiEndPoints}/documents/view`,
    getTermsConditions: `${apiEndPoints}/admin/terms-conditions`,
    getPrivacypolicy: `${apiEndPoints}/admin/privacy-policy`,
    getArticlesList: `${apiEndPoints}/articles/list`,
    getArticldetailsById: `${apiEndPoints}/articles/get-article-detail`,
    getScanDetails: `${apiEndPoints}/scan/get-details`,
    getScanHistory: `${apiEndPoints}/scan/history`,
    listWellnessCat: `${apiEndPoints}/category/list`,
    listBioMarker: `${apiEndPoints}/auth/biomarker-translation-list`,
    updateUserData: `${apiEndPoints}/user/update-scan`,
    exportUserScanDetails: `${apiEndPoints}/user/scan/export`,
    getHistoryDates: `${apiEndPoints}/user/scan/get-date`,
    getNotificationList: `${apiEndPoints}/user/notification-list`,
    readNotification: `${apiEndPoints}/user/notification-read`,
    getTimeZone: `${apiEndPoints}/res/get_timezone_list`,
    updateUserLanguage: `${apiEndPoints}/user/update-language`,
    notificationOnOff: `${apiEndPoints}/user/notification-on-off`,
    getuserDetails: `${apiEndPoints}/auth/get-user`,
    accessCodeVerification: `${apiEndPoints}/auth/verify-access-code`,
    googleLogin: `${apiEndPoints}/auth/google-sso-login`,
    appleLogin: `${apiEndPoints}/auth/apple-sso-login`,
    saveGuestUser: `${apiEndPoints}/user/guest-user`,
    getGuestUserList: `${apiEndPoints}/user/guest-user-list`,
    getGuestUserDetails: `${apiEndPoints}/user/guest-user-details`,
    createCampaign: `${apiEndPoints}/admin/create-campaign`,
    listCampaign: `${apiEndPoints}/admin/campaign-list`,
    campaignDetails: `${apiEndPoints}/admin/campaign-details`,
    stopCampaign: `${apiEndPoints}/admin/stop-campaign`,
    getScanLimit: `${apiEndPoints}/user/check-scan-limit`,
    updateServings: `${apiEndPoints}/user/update-servings`,
    fourLifeLogin: `${apiEndPoints}/auth/continue-with-4life`,
    webhookSignup: `${apiEndPoints}/webhook/signup`,
    recProductList: `${apiEndPoints}/prouct/recommendation-list`,
    deleteGuestUser: `${apiEndPoints}/user/guest-user-delete`,
    getFourLifeScanHistory: `${apiEndPoints}/user/scan/get-date-history`,
}